import { useEffect } from "react";

import { getBillingOrderToPost } from "../../api";
import { getAuthInfosFromCookie, authHasExpired } from "../../utils";

const PaymentSuccessRedirect = () => {
  useEffect(() => {
    let authInfos = getAuthInfosFromCookie();
    if (!authInfos || authHasExpired(authInfos)) {
      return null;
    }
    const token = authInfos.token;
    const paymentType = new URLSearchParams(window.location.search).get("type");
    const orderId = new URLSearchParams(window.location.search).get("orderId");

    let intervalId;

    const checkOrderStatus = async () => {
      try {
        const order = await getBillingOrderToPost(token, orderId);

        if (order.data.data) {
          if (order.data.data.toPostTreatment !== 1) {
            clearInterval(intervalId);
            if (paymentType && paymentType === "plan_subscription") {
              window.parent.location =
                window.parent.location + "?paymentSuccess=1";
            } else {
              window.parent.location = window.parent.location + "?ps=1"; // paymentSuccess = 1
            }
          }
        }
      } catch (e) {}
    };
    if (token) {
      intervalId = setInterval(checkOrderStatus, 2000);
    }

    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, []);

  return null;
};

export default PaymentSuccessRedirect;
